import React from 'react';
import styled from 'styled-components';
import ImageSlider from '../components/ImageSlider';
import PropertyDescription from '../components/PropertyDescription';
import AgentContactInfo from '../components/AgentContactInfo';
import PropertyHeader from '../components/PropertyHeader';
import { Helmet } from 'react-helmet-async';
import agent_info from '../vars/agentInfo';

// import pics
import backyard from "../pics/Legends5908/backyard.jpg";
import backyard1 from "../pics/Legends5908/backyard1.jpeg";
import backyard2 from "../pics/Legends5908/backyard2.jpeg";
import bedroom1 from "../pics/Legends5908/bedroom1.jpg";
import fireplace from "../pics/Legends5908/fireplace.jpeg";
import formalDining from "../pics/Legends5908/formalDining.jpg";
import formalDining1 from "../pics/Legends5908/formalDining1.jpg";
import front from "../pics/Legends5908/front.jpg";
import guestBath from "../pics/Legends5908/guestBath.jpg";
import kitchen1 from "../pics/Legends5908/kitchen1.jpg";
import kitchen2 from "../pics/Legends5908/kitchen2.jpg";
import kitchen3 from "../pics/Legends5908/kitchen3.jpg";
import laundryRoom from "../pics/Legends5908/laundryRoom.jpg";
import familyRoom from "../pics/Legends5908/familyRoom.jpg";
import livingRoom0 from "../pics/Legends5908/livingRoom0.jpg";
import livingRoom1 from "../pics/Legends5908/livingRoom1.jpg";
import master1 from "../pics/Legends5908/master1.jpg";
import master2 from "../pics/Legends5908/master2.jpg";
import masterBath from "../pics/Legends5908/masterBath.jpg";
import masterCloset from "../pics/Legends5908/masterCloset.jpg";
import nursery from "../pics/Legends5908/nursery.jpg";
import office from "../pics/Legends5908/office.jpg";



function Legends5908() {
    
    const slides = [
        {img:master1},
        {img:front},
        {img:livingRoom0},
        {img:livingRoom1},
        {img:formalDining},
        {img:formalDining1},
        {img:kitchen1},
        {img:kitchen3},
        {img:kitchen2},
        {img:familyRoom},
        {img:fireplace},
        {img:master2},
        {img:masterBath},
        {img:masterCloset},
        {img:office},
        {img:bedroom1},
        {img:nursery},     
        {img:guestBath},
        {img:laundryRoom},
        {img:backyard},
        {img:backyard2},
        {img:backyard1}
    ]
    const property_info = {
        address: "5908 Legends Ave NW 87120",
        key_details: {bedrooms:"3 Bedrooms + Office", bathrooms:"2 Full Bathrooms" , sqFootage:"Spacious 2330sqft", price:"Valued at $449,900"},
        description: "Step inside to experience this fabulously updated home. The vaulted ceilings and numerous windows offer amazing natural light. The kitchen and walk-in pantry make cooking a pleasure. There is plenty of space to entertain in the house or out in your new backyard. The 4 bedrooms are spacious and the bathrooms are updated with dual vanities. New flooring throughout, no carpet, granite countertops, new appliances, smart home with Nest doorbell and thermostat - all the perks of a new home without the wait. You'll love the serene neighborhood with no thru traffic. Just minutes away from shopping, dining, and trailheads. You don't want to miss out on the opportunity to own this one!",
        sale_pending: false, 
        sold: true,
        agent_info: agent_info.malory
    }
     
    return (
          <HomePageStyled>
            <Helmet>
                <meta 
                    name="description"  
                    content = "5908 Legends Ave NW 87120"
                    />

                <title>Big Dog Properties | 5908 Legends Ave 87120</title>
            </Helmet>
            <div className="typography"><PropertyHeader address={property_info.address} key_details={property_info.key_details}/></div>
            <div className='imageslider'>< ImageSlider slides = {slides} property_info={property_info}/></div>
            <div className='description'><PropertyDescription description={property_info.description}/></div>
            <div className='contact'><AgentContactInfo agent_info={property_info.agent_info}/></div>
          </HomePageStyled>
    );
  }
  
  export default Legends5908;

  const getHeight = () => {
    if (window.innerWidth < 475) {
        return window.innerHeight * .35
    }
    else if (window.innerWidth >= 475 && window.innerWidth < 650) {
        return window.innerHeight * .5
    }
    else if (window.innerWidth >= 650 && window.innerWidth < 850) {
        return window.innerHeight * .7
    }
    else if (window.innerWidth >= 850 && window.innerWidth < 1050) {
        return window.innerHeight * .85
    }
    else{
        let height = window.innerHeight * .95;
        return height
    }
  }




const HomePageStyled = styled.div`
display:block;
padding:1rem 0;
margin:1rem 0;
margin-right:1rem;
// border:solid 2px yellow;
.typography{

}
.contact{
    // border:solid 2px white;
    color: var(--white-color);
    text-align: left;
    margin-top:1rem;
    align-items:center;
}
.imageslider{
    // border:solid 2px orange;
    height:${getHeight}px;
    // width:90%;
    padding-bottom:.5rem;
    margin-bottom:.5rem;
    padding-top:.5rem;
    margin-top:.5rem;
}
.description{
    // border:solid 2px orange;
    content-justify:center;
    align-items:center;
    text-align:center;
}
h1{
    font-size:2rem;
    color:var(--white-color);
    span{
        font-size:2rem;
        color:var(--primary-color);
    }
}
h2{
    font-size:1.5rem;
    // color:var(--white-color);
    span{
        font-size:1.5rem;
        color:var(--primary-color);
    }
}

`;
